/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Property } from "../../property/types/Property";
export const FieldConfigResponse = core.serialization.object({
    data: Property,
});
